export default {
  'date':timeStamp => {
    if (!timeStamp) return '0000-00-00';
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = String(timeStamp).length > 10;
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp)
    // 继续计算
    const d = new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    return year + '-' + month + '-' + date;
  },
  'datetime':timeStamp => {
    if (!timeStamp) return '0000-00-00 00:00:00';
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = String(timeStamp).length > 10;
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp)
    // 继续计算
    const d = new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second;
  },
  'time':timeStamp => {
    if (!timeStamp) return '00:00:00';
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = String(timeStamp).length > 10;
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp)
    // 继续计算
    const d = new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    return hours + ':' + minutes + ':' + second;
  },
  'telHide':tel => {
    tel = "" + tel;
    // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
    var reg = /(\d{3})\d{4}(\d{4})/;
    //$1是第一个小括号里的 ,$2是第2个小括号里的
    return tel.replace(reg, "$1****$2")
  }
}

const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}